const ErrorPage = () => {
    return(
        <>
            <h2 className='errorH2'>Oh no, page not found!</h2>
            <div className="tenor-gif-embed" data-postid="8957635" data-share-method="host" data-aspect-ratio="1.36047" data-width="100%">
                <a href="https://tenor.com/view/patrick-rage-fridge-spongebob-gif-8957635">Patrick Rage GIF </a>
                from 
                <a href="https://tenor.com/search/patrick-gifs"> Patrick GIFs</a>
            </div> 
        </>
    )
}

export default ErrorPage;